import { render } from "./SupplierPrivateCompanyContactDetail.vue?vue&type=template&id=1d6f4fae&ts=true"
import script from "./SupplierPrivateCompanyContactDetail.vue?vue&type=script&lang=ts"
export * from "./SupplierPrivateCompanyContactDetail.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__